import PptxGenJS from "pptxgenjs";

export const slide5 = (pptx: PptxGenJS, data: any) => {
    const slide = pptx.addSlide();
    const reportData = data?.data;
    slide.addImage({
        path: '/Access-Holdings-Logo.jpg',
        x: 0.5,
        y: 0.2,
        w: 1.3,
        h: 0.45
    });
    slide.addText("Rater Differences", {
        x: 0.5,
        y: 0.8,
        w: 7.27,
        h: 0.5,
        fontSize: 20,
        bold: true,
        color: '000000'
    });
    slide.addText([
        { text: "The behaviors listed below had the ", options: { fontSize: 10, color: '404040' } },
        { text: "largest gaps between rater groups.", options: { fontSize: 10, color: '404040', bold: true } }
    ], {
        x: 0.5,
        y: 1.25,
        w: 7.27,
        h: 0.3
    });
    const questionsWithRaters = reportData?.participantReport?.combinedQuestions?.filter(
        (q: any) => q.raters && q.raters.length > 0
    ) || [];
    const questionsWithGaps = questionsWithRaters.map((q: any) => {
        const supervisorData = q.raters.find((r: any) => r.review_type === "Supervisor");
        const peerData = q.raters.find((r: any) => r.review_type === "Peer");
        const directData = q.raters.find((r: any) => r.review_type === "Direct Report");

        const scores = {
            supervisor: supervisorData?.avg_score || 0,
            peer: peerData?.avg_score || 0,
            direct: directData?.avg_score || 0
        };

        const allScores = [scores.supervisor, scores.peer, scores.direct].filter(s => s > 0);
        const maxGap = allScores.length > 1 ? Math.max(...allScores) - Math.min(...allScores) : 0;

        return {
            ...q,
            scores,
            maxGap,
            highScore: Math.max(...allScores),
            lowScore: Math.min(...allScores)
        };
    });

    const top5Gaps = questionsWithGaps
        .sort((a: any, b: any) => b.maxGap - a.maxGap)
        .slice(0, 5);

    // Table setup
    const tableTop = 1.7;
    const colW = [1.8, 2.5, 0.95, 0.95, 1.0];
    const rowH = 0.9;
    const headerH = 0.6;
    const colors = {
        teal: '008080',
        gold: 'FFD700',
        grey: 'F8F8F8'
    };

    // Table Header Backgrounds
    slide.addShape('rect', { x: 0.5, y: tableTop, w: colW[0], h: headerH, line: { color: '404040', width: 1 } });
    slide.addShape('rect', { x: 0.5 + colW[0], y: tableTop, w: colW[1], h: headerH, line: { color: '404040', width: 1 } });
    slide.addShape('rect', { x: 0.5 + colW[0] + colW[1], y: tableTop, w: colW[2], h: headerH, fill: { color: 'FFFFFF' }, line: { color: '404040', width: 1 } });
    slide.addShape('rect', { x: 0.5 + colW[0] + colW[1] + colW[2], y: tableTop, w: colW[3], h: headerH, line: { color: '404040', width: 1 } });
    slide.addShape('rect', { x: 0.5 + colW[0] + colW[1] + colW[2] + colW[3], y: tableTop, w: colW[4], h: headerH, fill: { color: 'FFFFFF' }, line: { color: '404040', width: 1 } });
    // Header Text
    const headers = ["COMPETENCIES", "BEHAVIORS", "SUPERVISOR", "PEERS", "DIRECT REPORTS"];
    const headerX = [0.5, 0.5 + colW[0], 0.5 + colW[0] + colW[1], 0.5 + colW[0] + colW[1] + colW[2], 0.5 + colW[0] + colW[1] + colW[2] + colW[3]];
    headers.forEach((h, i) => {
        slide.addText(h, {
            x: headerX[i], y: tableTop, w: colW[i], h: headerH,
            fontSize: 8, bold: true, align: 'center', valign: 'middle',
            color: '000000'
        });
    });
    // Render rows
    top5Gaps.forEach((row: any, i: number) => {
        const y = tableTop + headerH + (i * rowH);
        // Competency cell
        slide.addShape('rect', { x: 0.5, y: y, w: colW[0], h: rowH, line: { color: '404040', width: 1 } });
        slide.addText(row.tag || '', { x: 0.6, y: y, w: colW[0] - 0.2, h: rowH, fontSize: 10, bold: true, align: 'center', valign: 'middle' });
        // Behavior cell
        slide.addShape('rect', { x: 0.5 + colW[0], y: y, w: colW[1], h: rowH, line: { color: '404040', width: 1 } });
        slide.addText(row.text || '', { x: 0.5 + colW[0] + 0.1, y: y, w: colW[1] - 0.2, h: rowH, fontSize: 9, color: '595959', valign: 'middle' });
        // Helper function to determine cell styling
        const getCellStyle = (score: number) => {
            if (score === row.highScore) return { fill: colors.teal, color: 'FFFFFF' };
            if (score === row.lowScore) return { fill: colors.gold, color: '000000' };
            return { fill: undefined, color: '000000' };
        };
        // Manager cell
        const mStyle = getCellStyle(row.scores.supervisor);
        slide.addShape('rect', { x: headerX[2], y: y, w: colW[2], h: rowH, fill: mStyle.fill ? { color: mStyle.fill } : undefined, line: { color: '404040', width: 1 } });
        slide.addText(row.scores.supervisor.toFixed(1), { x: headerX[2], y: y, w: colW[2], h: rowH, fontSize: 22, bold: true, color: mStyle.color, align: 'center', valign: 'middle' });
        // Peer cell
        const pStyle = getCellStyle(row.scores.peer);
        slide.addShape('rect', { x: headerX[3], y: y, w: colW[3], h: rowH, fill: pStyle.fill ? { color: pStyle.fill } : undefined, line: { color: '404040', width: 1 } });
        slide.addText(row.scores.peer.toFixed(1), { x: headerX[3], y: y, w: colW[3], h: rowH, fontSize: 22, bold: true, color: pStyle.color, align: 'center', valign: 'middle' });
        // Direct cell
        const dStyle = getCellStyle(row.scores.direct);
        slide.addShape('rect', { x: headerX[4], y: y, w: colW[4], h: rowH, fill: dStyle.fill ? { color: dStyle.fill } : undefined, line: { color: '404040', width: 1 } });
        slide.addText(row.scores.direct.toFixed(1), { x: headerX[4], y: y, w: colW[4], h: rowH, fontSize: 22, bold: true, color: dStyle.color, align: 'center', valign: 'middle' });
    });
    // Legend
    const legendY = tableTop + headerH + (5 * rowH) + 0.3;
    slide.addShape('rect', { x: 0.5, y: legendY, w: 0.2, h: 0.2, fill: { color: colors.teal }, line: { type: 'none' } });
    slide.addText("High Score", { x: 0.8, y: legendY, w: 1, h: 0.2, fontSize: 9, color: '404040', valign: 'middle' });

    slide.addShape('rect', { x: 2.0, y: legendY, w: 0.2, h: 0.2, fill: { color: colors.gold }, line: { type: 'none' } });
    slide.addText("Low Score", { x: 2.3, y: legendY, w: 1, h: 0.2, fontSize: 9, color: '404040', valign: 'middle' });
    // Footnote text
    const footnoteY = legendY + 0.5;
    const footnote = "Each rater group interacts with you in a different setting. These differences allow for unique perspectives on your leadership attributes. A large difference in ratings indicates that your behavior comes across differently to different people. Think about these differences as you put together your individual development plan.";
    slide.addText(footnote, {
        x: 0.5,
        y: footnoteY,
        w: 7.27,
        h: 1.0,
        fontSize: 10,
        color: '595959'
    });

    // Footer
    const candidateName = data?.candidateName || 'Jane Doe';
    slide.addText(`360-Degree Feedback Individual Report for ${candidateName}`, {
        x: 0,
        y: 11.2,
        w: 7.8,
        h: 0.3,
        fontSize: 9,
        color: '666666',
        align: 'center'
    });

    // slide.addText("5", {
    //     x: 7.8,
    //     y: 11.2,
    //     w: 0.4,
    //     h: 0.3,
    //     fontSize: 9,
    //     color: '666666',
    //     align: 'center'
    // });
};